import {
  BaSeButton,
  BaSeDataTable,
  BaSeParagraph,
  BaSeSelect,
  BaSeSmall1,
  BaSeTheme,
} from '@base/react';

import * as Sebrae from '@sebrae/react-core';
import React from 'react';

import { useCityController } from '../../../../../../hooks/controllers/city-controller';
import { useUfController } from '../../../../../../hooks/controllers/uf-controller';
import { cpfMask } from '../../../../../../utils/formatters/cpfMask';
import { useMenu } from '../../hook/useMenu';
import { useCandidateController } from './../../../../../../hooks/controllers/candidate-controller';
import ButtonAcessInterview from './button-acess-interview';
import {
  AlignButton,
  AlignCustomFilter,
  Container,
} from './general-search-style';
import SearchInput from './search-input';

export const GeneralSearch = ({
  closeModal,
  handleCpfSearched,
  fetchDataInterview,
}) => {
  const {
    fetchData: fetchDataCandidate,
    data,
    loading,
  } = useCandidateController();

  const { openDialogCpf, openDialogNewCandidate, openDialogActiveInterview } =
    useMenu();

  const { listUfs, getUfs } = useUfController();
  const { getCitiesByUf, listCities } = useCityController();
  const [ufSelected, setUfSelected] = React.useState({ id: 0, label: '' });

  React.useEffect(() => {
    getUfs();
  }, [getUfs, listCities]);

  const configTable = [
    {
      accessorKey: 'name',
      header: 'Nome do candidato',
      mapper: ({ values }) => (
        <BaSeParagraph
          isBold
          color={BaSeTheme.colors.institucionais.cinzaSebrae45}
        >
          {values.name}
        </BaSeParagraph>
      ),
    },
    {
      accessorKey: 'cpf',
      header: 'CPF',
      mapper: ({ values }) => {
        return (
          <BaSeSmall1 color={BaSeTheme.colors.institucionais.cinzaSebrae45}>
            {cpfMask(values.cpf)}
          </BaSeSmall1>
        );
      },
    },
    {
      accessorKey: 'entrevista',
      header: 'Possui entrevista em',
      mapper: ({ values }) => {
        return (
          <div>
            {values.modules?.map((module) => (
              <ButtonAcessInterview
                key={module.name}
                closeModal={closeModal}
                handleCpfSearched={handleCpfSearched}
                name={module.name}
                color={module.settingsMap.primaryColor}
                idModulo={module.id}
                cpf={values.cpf}
              />
            ))}
          </div>
        );
      },
    },
  ];

  const resolverUf = (value) => {
    if (value.label === 'Selecione') {
      return { id: 0, label: '' };
    }

    return value;
  };

  const buildCustomFilter = React.useCallback(
    (setFilter) => {
      return (
        <AlignCustomFilter>
          <SearchInput setFilter={setFilter} />
          <BaSeSelect
            width={'20%'}
            label="UF do seminário:"
            color={BaSeTheme.colors.institucionais.cinzaSebrae10}
            values={listUfs}
            onChange={(value) => {
              getCitiesByUf(value);
              setUfSelected(resolverUf(value));
            }}
          />

          <BaSeSelect
            isDisabled={ufSelected.id === 0 ? true : false}
            label="Cidade:"
            width={'30%'}
            color={BaSeTheme.colors.institucionais.cinzaSebrae10}
            values={listCities?.[ufSelected.id]}
            searchable
            onChange={(value) => {
              setFilter((prev) => ({
                ...prev,
                uf: ufSelected.label,
                city: resolverUf(value).label,
              }));
            }}
          />
        </AlignCustomFilter>
      );
    },
    [getCitiesByUf, ufSelected, listCities, listUfs],
  );

  const cache = Sebrae.StorageUtil.inTemporaryStore();

  return (
    <div>
      <Container withAutoScroll>
        <BaSeDataTable
          singularItemDescription="candidato"
          pluralItemDescription="candidatos"
          genderOfItemDescription="male"
          config={configTable}
          fetchData={fetchDataCandidate}
          backgroundColor={BaSeTheme.colors.defaultColors.white}
          foregroundColor={BaSeTheme.colors.institucionais.cinzaSebrae60}
          highlightedColor={BaSeTheme.colors.institucionais.cinzaSebrae30}
          separatorColor={BaSeTheme.colors.institucionais.cinzaSebrae90}
          filterAreaBackgroundColor={BaSeTheme.colors.defaultColors.white}
          shadow={data.total > 0 ? '0  4px  8px 0 rgba(20, 46, 82, 0.2)' : ''}
          items={data.items}
          total={data.total}
          isLoading={loading}
          hasPagination
          hasCustomFilter
          customFilterVisible
          customFilterIconVisible={false}
          textFilterAlwaysVisible
          initialPageSize={5}
          renderCustomFilter={({ setFilter }) => buildCustomFilter(setFilter)}
          initialPageIndex={1}
          hasHeader={false}
          width={'97%'}
        />
      </Container>

      <AlignButton>
        <BaSeButton
          buttonType="button"
          color={BaSeTheme.colors.defaultColors.black}
          leftIcon="plus"
          loadingText="Carregando..."
          rightIcon=""
          size="medium"
          type="primary"
          value="Novo Candidato"
          width=""
          onClick={() => {
            closeModal('close');
            cache.setItem('withGeneralSearch', true);

            openDialogCpf(
              openDialogActiveInterview,
              openDialogNewCandidate,
              fetchDataInterview,
            );
          }}
        />
      </AlignButton>
    </div>
  );
};
